angular.module('tgaAdmin')
  .service('notificationService', ['$http', '$timeout', 'envService',
    function ($http, $timeout, envService) {
      const serverAddress = envService.read('serverAddress');
      const unread = { value: 0 };
      let timer = null;

      function getUnread() {
        return $http({
          method: 'GET',
          url: `${serverAddress}notification/unread`,
        }).then(
          (response) => {
            unread.value = response.data;
            return response.data;
          },
          (error) => {
            throw error.data;
          },
        );
      }

      function poll() {
        getUnread();
        timer = $timeout(() => {
          getUnread();
        }, 30000);
      }

      function destroy() {
        $timeout.cancel(timer);
      }

      function getNotifications(params) {
        return $http({
          method: 'GET',
          url: `${serverAddress}notification`,
          params,
        }).then(
          (response) => response.data.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function markRead(id) {
        return $http({
          method: 'POST',
          url: `${serverAddress}notification/read/${id}`,
        }).then(
          (response) => {
            getUnread();
            return response.data.data;
          },
          (error) => {
            throw error.data;
          },
        );
      }

      function deleteNotification(id) {
        return $http({
          method: 'DELETE',
          url: `${serverAddress}notification/${id}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        unread,
        poll,
        destroy,
        getNotifications,
        getUnread,
        markRead,
        deleteNotification,
      });
    }]);
